import { useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

const UpdateEarlySubmission = ({
    allowEarlyFormSubmissionRegistrationPage, // redux state
    allowEarlyFormSubmissionStorePage, // redux state
    shouldAllowEarlyFormSubmissionRegistrationPage, // this is not redux state
    shouldAllowEarlyFormSubmissionStorePage, // this is not redux state
    isCms = false,
    setAllowEarlyFormSubmissionRegistrationPage,
    setAllowEarlyFormSubmissionStorePage,
}) => {
    const dispatch = useDispatch();
    // TODO: fix this problem
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = !isCms ? useLocation() : "";
    const isRegistrationPage =
        pathname && pathname.includes("form/registration");
    const isStorePage = pathname && pathname.includes("form/store");

    // tracks what early submit from registration page should be
    // updates state if there is a miss match
    useEffect(() => {
        if (
            isRegistrationPage &&
            allowEarlyFormSubmissionRegistrationPage !==
                shouldAllowEarlyFormSubmissionRegistrationPage
        ) {
            // set to new value
            dispatch(
                setAllowEarlyFormSubmissionRegistrationPage(
                    shouldAllowEarlyFormSubmissionRegistrationPage,
                ),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldAllowEarlyFormSubmissionRegistrationPage, isRegistrationPage]);

    // tracks what early submit from store page should be
    // updates state if there is a miss match
    useEffect(() => {
        if (
            isStorePage &&
            allowEarlyFormSubmissionStorePage !==
                shouldAllowEarlyFormSubmissionStorePage
        ) {
            // set to new value
            dispatch(
                setAllowEarlyFormSubmissionStorePage(
                    shouldAllowEarlyFormSubmissionStorePage,
                ),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldAllowEarlyFormSubmissionStorePage, isStorePage]);

    // When not viewing correct page, sets early submit to false for that page
    useEffect(() => {
        if (pathname && !pathname.includes("form/registration")) {
            setAllowEarlyFormSubmissionRegistrationPage(false);
        }
        if (pathname && !pathname.includes("form/store")) {
            setAllowEarlyFormSubmissionStorePage(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return null;
};

UpdateEarlySubmission.propTypes = {
    // Flag for allowing early registration from registration page
    allowEarlyFormSubmissionRegistrationPage: PropTypes.bool.isRequired,
    // Flag for allowing early registration from store page
    allowEarlyFormSubmissionStorePage: PropTypes.bool.isRequired,
    // Flag for what the current value of allowEarlyFormSubmissionRegistrationPage should be
    shouldAllowEarlyFormSubmissionRegistrationPage: PropTypes.bool.isRequired,
    // Flag for what the current value of allowEarlyFormSubmissionStorePage should be
    shouldAllowEarlyFormSubmissionStorePage: PropTypes.bool.isRequired,
    // Flag for cms view
    isCms: PropTypes.bool.isRequired,
    setAllowEarlyFormSubmissionRegistrationPage: PropTypes.func.isRequired,
    setAllowEarlyFormSubmissionStorePage: PropTypes.func.isRequired,
};

export default UpdateEarlySubmission;
